import { configureStore, combineReducers, applyMiddleware } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query'
import storage from 'redux-persist/lib/storage';


import {
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import loadingSlice from './loading/loadingSlice';
import authSlice from './auth/authSlice';
import searchValueSlice from './searchValue/searchValueSlice';
import requirementTypeSlice from './requirement/requirement';
import combineReducer from './requirement/requirement';
import toggleMenu from './hamburgerMenu';

const persistConfig = {
    key: 'root',
    storage: storage,
    blacklist: [],
    whitelist: ['auth', 'app', 'profileForm', 'loginDetails'],
}

export const rootReducers = combineReducers({
    loading: loadingSlice,
    auth: authSlice,
    searchValue: searchValueSlice,
    requirementAnsSupport: combineReducer,
    toggleMenu: toggleMenu

});

const persistedReducer = persistReducer(persistConfig, rootReducers)
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        })
    //.concat(apiSlice.middleware),
});


setupListeners(store.dispatch)
export default store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch